import { InfoEmpty } from 'iconoir-react';
import { Tooltip } from './Tooltip';

type TextInfoProps = {
    info: string;
    children: React.ReactNode;
};
export const TextInfo = ({ children, info }: TextInfoProps) => {
    return (
        <div className="flex items-start space-x-1 md:whitespace-pre sm:whitespace-normal">
            <span>{children}</span>
            <Tooltip title={info} position="top" arrowSize="small">
                <InfoEmpty className="inline-block -mt-1" width={16} height={16} strokeWidth={1.75} fr="true" />
            </Tooltip>
        </div>
    );
};
